import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';

/**
 * # SubContentInfos
 *
 * SubContentInfos 설명하세요.
 */
export const SubContentInfos = types
  .model('SubContentInfos')
  .props({
    title: types.maybeNull(types.string),
    descript: types.maybeNull(types.string),
    desktopImagePath: types.optional(types.array(types.string), []),
    mobileImagePath: types.optional(types.array(types.string), []),
  })
  .volatile(() => ({
    // 데스크탑 이미지
    desktopImageFiles: [] as File[],
    deleteDesktopImageFiles: [] as string[],
    // 모바일 이미지
    mobileImageFiles: [] as File[],
    deleteMobileImageFiles: [] as string[],
  }))
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TSubContentInfos = Instance<typeof SubContentInfos>;
type TSubContentInfosSnapshot = SnapshotOut<typeof SubContentInfos>;

export interface ISubContentInfos extends TSubContentInfos {}
export type TSubContentInfosKeys = keyof TSubContentInfosSnapshot & string;
export interface ISubContentInfosSnapshot extends TSubContentInfosSnapshot {}
export const createSubContentInfos = (): ISubContentInfos => {
  return SubContentInfos.create({
    title: '',
    descript: '',
    desktopImagePath: [],
    mobileImagePath: [],
  });
};
